import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const h2Theme = createTheme({
  h2: {
    base: "text-xl sm:text-2xl font-semibold",
    colors: {
      base: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
    },
  },
}).h2;

type H2Props = {
  children: React.ReactNode
  color?: keyof typeof h2Theme.colors
  className?: string
} & ComponentProps<"h2">;

const H2 = ({
  children,
  color = "base",
  className = "",
  ...props
}: H2Props) => {
  return (
    <h2
      className={`${h2Theme.base} ${h2Theme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </h2>
  );
};

H2.displayName = "H2";

export { H2 };
export type { H2Props };
